import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { FilterPanelComponent } from "src/app/shared/components/filter-panel/filter-panel.component";

/**
 * Custom Formly field type for multi-select filter panels.
 * Wraps FilterPanelComponent.
 *
 * Usage:
 * ```typescript
 * {
 *   key: 'AreaOfInterests',
 *   type: 'multi-select-panel',
 *   props: {
 *     label: 'Field of interest',
 *     selectionType: 'checkbox', // or 'radio'
 *     options: [{ value: 'tech', label: 'Technology' }]
 *   }
 * }
 * ```
 */
@Component({
  selector: "formly-multi-select-panel",
  imports: [FilterPanelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-filter-panel
      [type]="props.selectionType || 'checkbox'"
      [title]="props.label || ''"
      [options]="$any(props.options) || []"
      [tags]="$any(props.tags) || []"
      [value]="formControl.value"
      (valueChange)="onValueChange($event)"
    />
  `,
})
export class MultiSelectPanelFieldType extends FieldType<FieldTypeConfig> {
  onValueChange(value: any): void {
    this.formControl.setValue(value);
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
  }
}
